import Vue from 'vue'
import Treeselect from '@riophae/vue-treeselect'

import '@riophae/vue-treeselect/dist/vue-treeselect.css'

Vue.component('gw-treeselect', Treeselect)
